$(window).on('pageshow', function(){
    $('body').removeClass('onLoading');
    $(".idoc-main-search button[type='submit']").removeClass('on-search').html('<i class="icon-idoc-ai-01" aria-hidden="true"></i> Cerca con AI');
});

$(document).ready(function() {

    if ($('form .cercatore').length) {
        $('.idoc-main-search button[type="submit"]').prop('disabled', false);
        $('#showsearcher, .search_close').on('click', function(e) {
            $('#navbarMenu').collapse('hide');
            if (window.innerWidth > 991) {
                if ($(this).attr('id') == 'showsearcher') {
                    if ($('#searchWhat').is(':visible')) {
                        $(this).html('<i class="fas fa-search"></i> Cerca</a>')
                    } else {
                        $(this).html('<i class="fas fa-times"></i> Chiudi</a>')
                    }
                }
            }

            $('#searchWhat').slideToggle();
            setTimeout(function() {
                if($('#searchWhat').is(':visible')) {
                    //$('.searchwhat:first').focus();
                }
            }, 100);
        })

        // $(".searchwhere").on("click focus",function() {
        //     if (!$(this).prop('disabled') && $(this).val() == "Vicino a te") {
        //         $(this).val("");
        //     }
        // });

        // $(".searchwhere").on("blur",function() {
        //     if (!$(this).prop('disabled') && $(this).val() == "") {
        //         $(this).val("Vicino a te");
        //         $(this.form).find('.where_id').val("nearby");
        //     }
        // });

        $(".idoc-main-search").on('keydown', function(e) {
            if (e.keyCode == 13) {
                e.preventDefault();
                $(this).submit();
            }
        });
        $(".idoc-main-search").on('click', function(e) {
            if ($(e.target).closest('li').length && $(e.target).closest('li').closest('.typeahead').length) {
                e.preventDefault();
                $(".idoc-main-search").submit();
            }
        });    
        $(".idoc-main-search").on('submit',function(e) {
            if ($(this).find('.searchwhat').val() == "") {
                //showError('Per continuare devi selezionare almeno un elemento di ricerca');
                window.location.href = base_url + 'ai';
                return false;
            }
            // if(!parseInt($(this).find('.search_id').val()) > 0) {
            //     showError('Per continuare devi selezionare almeno un elemento di ricerca');
            //     return false;
            // }

            // if($(this).find('.search_tipo').val() == "prestazione" && $(this).find(".searchwhere").val() == "") {
            //     showError('Per continuare devi selezionare almeno una provincia oppure una città');
            //     return false;
            // }


            // if($(this).find(".where_id").val() == "nearby" && $(this).find('.search_tipo').val() != "medico" && $(this).find('.search_tipo').val() != "clinica") {
            //    /**
            //      * Queste sono patologie / interventi / trattamenti, ma nerby funziona come type keyword ecco perchè l'if else
            //      */
            //     if($(this).find('.search_tipo').val() != 'specializzazione' && $(this).find('.search_tipo').val() != 'prestazione') {
            //         redirect_nearby('keyword', $(this).find('.search_id').val());
            //         return false;
            //     }
            //     redirect_nearby($(this).find('.search_tipo').val(), $(this).find('.search_id').val());
            //     return false;
            // }
            $(this).find('button[type="submit"]').addClass('on-search').html('<i class="fas fa-spinner fa-spin" aria-hidden="true"></i>'); /*.attr('disabled','disabled'); */
            $('body').addClass('onLoading');
            return true;
        });

        let intervalWhat = null;

        $('.searchwhat').typeahead({
            minLength: 3,
            autoSelect: false,
            matcher: function() {
                return true;
            },
            fitToElement: true,
            items: 'all',
            sorter: function (texts) {
                return texts;
            },
            source: function (query, result) {
                var form = $(this.$element[0]).closest('form');
                form.find('.search_id').val("");
                form.find('.search_tipo').val("");
                if (intervalWhat) clearTimeout(intervalWhat);

                intervalWhat = setTimeout(function() {
                    httpRequest(api_url + 'search-what', {q: query}, {showLoader: false}).then(data => {
                        // if(!data.data.result) {
                        //     if(data.data.result.length == 0) {
                        //         data.data.result.push({
                        //             id: 0,
                        //             nome: "Nessun risultato trovato per \"" + query + "\"",
                        //             tipo: "",
                        //             extra: ""
                        //         });
                        //     }
                        // } else {
                        //     data.data.result = [{
                        //         id: 0,
                        //             nome: data.error,
                        //             tipo: "",
                        //             extra: ""
                        //     }]
                        // }
                        result($.map(data.data.result, function (item) {
                            return item.id + "@@" + item.nome + "@@" + item.tipo + "@@" + item.extra;
                        }));
                        $(data.data.result).each(function(k,v) {
                            if(v.nome.toLowerCase().trim() == query.toLowerCase().trim()) {
                                form.find('.search_id').val(v.id);
                                form.find('.search_tipo').val(v.tipo);
                            }
                        });
                    })

                    if($('body').hasClass('page-home')) {
                        g4_event("Search",{'event_category' : "Home", 'value' : "What"});
                    }
                }, 400);

            },
            highlighter: function (item) {
                /* questo cambia l'html dei risultati */
                var originalHL = $.fn.typeahead.Constructor.prototype.highlighter;
                var parts = item.split('@@');
                var text = parts[1];
                var hl_text = originalHL.call(this, text);
                if(parts[2] == "") {
                    return hl_text;
                } else if(parts[2] == "medico") {
                    return "<img src='"+parts[3]+"' class='img-fluid rounded-circle img-search-medico' loading='lazy' /> " + hl_text;
                } else if(parts[2] == "clinica") {
                    return "<img src='"+parts[3]+"' class='img-fluid rounded-circle img-search-clinica' loading='lazy' /> " + hl_text;
                } else if(parts[2] == "specializzazione") {
                    return "<i class='fas fa-circle text-primary'> </i> " + hl_text;
                } else if(parts[2] == "prestazione") {
                    return "<i class='fas fa-circle text-success'> </i> " + hl_text;
                } else {
                    return "<i class='fas fa-circle text-danger'> </i> " + hl_text;
                }
            },
            updater: function (item) {            
                var form = $(this.$element[0]).closest('form');
                var parts = item.split('@@');
                if(parts[0] > 0) {
                    var text = parts[1];
                    if(parts[2] == 'specializzazione' && parts[3] != 'null') {
                        form.find('.search_id').val(parts[3]);
                        form.find('.search_tipo').val('prestazione');
                    } else {
                        form.find('.search_id').val(parts[0]);
                        form.find('.search_tipo').val(parts[2]);
                    }
                    form.find('.searchwhat').val(text);
                    //form.trigger("submit");
                    return text;
                }

                return false;
            }
        });

        let intervalWhere = null;

        // $('.searchwhere').typeahead({
        //     minLength: 3,
        //     matcher: function() {
        //         return true;
        //     },
        //     fitToElement: true,
        //     items: 'all',
        //     sorter: function (texts) {
        //         return texts;
        //     },
        //     source: function (query, result) {
        //         var form = $(this.$element[0]).closest('form');
        //         if (intervalWhere) clearTimeout(intervalWhere);

        //         intervalWhere = setTimeout(function() {
        //             httpRequest(api_url + 'search-where', {q: query}, {showLoader: false}).then(data => {
        //                 if(data.result) {
        //                     if(data.data.length == 0) {
        //                         data.data.push({
        //                             ID: "0",
        //                             nome: "Nessuna città trovata per \"" + query + "\""
        //                         });
        //                         data.data.push({
        //                             ID: "nearby",
        //                             nome: "Vicino a te"
        //                         });
        //                     } else {
        //                         data.data.unshift({
        //                             ID: "nearby",
        //                             nome: "Vicino a te"
        //                         });
        //                     }
        //                 } else {
        //                     data.data = [{
        //                         ID: "0",
        //                         nome: data.error
        //                     }]
        //                 }
        //                 result($.map(data.data, function (item) {
        //                     return item.ID + "@@" + item.nome + "@@" + item.latitudine + "@@" + item.longitudine;
        //                 }));
        //                 $(data.data).each(function(k,v) {
        //                     if(v.nome.toLowerCase().trim() == query.toLowerCase().trim()) {
        //                         form.find('.where_id').val(v.ID);
        //                         form.find('.where_lat').val(v.latitudine);
        //                         form.find('.where_lng').val(v.longitudine);
        //                     }
        //                 });
        //             })

        //             if($('body').hasClass('page-home')) {
        //                 g4_event('Search', {'event_category' : 'Home', 'value' : "Where" });
        //             }
        //         }, 400);
        //     },
        //     highlighter: function (item) {
        //         var originalHL = $.fn.typeahead.Constructor.prototype.highlighter;
        //         var parts = item.split('@@');
        //         var text = parts[1];
        //         var hl_text = originalHL.call(this, text);
        //         if(parts[0] == "nearby") {
        //             return "<i class='fas fa-map-marker text-danger'></i> " + hl_text;
        //         } else {
        //             return hl_text;
        //         }
        //     },
        //     updater: function(item) {
        //         var form = $(this.$element[0]).closest('form');
        //         var parts = item.split('@@');
        //         var text = parts[1];
        //         if (parts[0]!=0) {
        //             form.find('.where_id').val(parts[0]);
        //         }
        //         form.find('.where_lat').val(parts[2]);
        //         form.find('.where_lng').val(parts[3]);
        //         form.find('.searchwhere').val();
        //         return text;
        //     }
        // });

        /* check sullo scroll tramite freccette nel widget di ricerca */
        $(".typeahead").on("keydown",function (e) {
            switch (e.keyCode) {
                case 40:
                    $('li.active')[0].scrollIntoViewIfNeeded();
                    break;
                case 38:
                    $('li.active')[0].scrollIntoViewIfNeeded();
                    break;
            }
        });


    }
});
